import { FC, useContext, useEffect } from 'react'
import { classes, stylesheet } from 'typestyle'
import moment from 'moment'
import { important } from 'csx'

/* Hooks ======================================================================================== */
import useValue from '../../hooks/use-value'
import useBoolean from '../../hooks/use-boolean'

/* Components =================================================================================== */
import { TextField } from '../../components/text-field'
import { FormContext } from '../../components/form'
import { FieldWrapper } from './field-wrapper'

/* Styles ======================================================================================= */

export const formatDate = (date: any) => {
  if (date && date !== '-') {
    return moment(date)
      .utc()
      .format('yyyy-MM-DD')
  }

  return '-'
}

export const DateField: FC<{
  label: string
  name: string
  validate?: any
  disableWrap?: boolean
  disabled?: boolean
}> = props => {
  const { label, name, disableWrap, disabled } = props
  const formContext = useContext(FormContext)
  const { value } = formContext
  const [loaded, $loaded] = useBoolean()
  const form: any = value.form
  const [date, $date] = useValue()

  useEffect(() => {
    if (!loaded && form[name] && !value) {
      $date.set(new Date(formatDate(form[name])))
      $loaded.set(true)
    }
  }, [loaded, form[name], value])

  const handleBeforeSubmit: any = (data: any) => {
    return data || ''
  }

  return (
    <TextField
      disabled={disabled}
      className={STYLES.container}
      name={name}
      label={label}
      value={date}
      type="date"
      lang={process.env.REACT_APP_LANGUAGE || 'en-CA'}
      beforeSubmit={handleBeforeSubmit}
      wrapper={!disableWrap && FieldWrapper}
      wrapperProps={{ label, name }}
      validate={props.validate}
    />
  )
}

const STYLES = stylesheet({
  container: {
    $nest: {
      'input::-webkit-calendar-picker-indicator': {
        cursor: 'pointer',
      },
    },
  },
  icon: {
    marginTop: -2,
    fontSize: important('16px'),
  },
})
